import { render, staticRenderFns } from "./recycleBox.vue?vue&type=template&id=5663277e&"
import script from "./recycleBox.vue?vue&type=script&lang=js&"
export * from "./recycleBox.vue?vue&type=script&lang=js&"
import style0 from "./recycleBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports